import { Checkbox as CheckboxComponent } from 'blaze-ui/Checkbox/Checkbox'
import Styles from './PersistentToast.module.scss'

interface CheckboxProps {
  checked: boolean
  onChange: (checked: boolean) => void
  label: string
}

export const Checkbox = ({ checked, onChange, label }: CheckboxProps) => {
  return (
    <div className={Styles.checkboxContainer}>
      <CheckboxComponent isSelected={checked} onChange={onChange} color="var(--light-100)">
        <span className={Styles.checkboxLabel}>{label}</span>
      </CheckboxComponent>
    </div>
  )
}
